import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';
import queryString from 'query-string';

export default function setShippingInfo({
    baseUrl,
    brandId,
    country,
    uberToken,
    body,
    clientId,
    clientSecret,
    clearMessages = true,
    langId,
    additionalHeaders = {},
}) {
    invariant(baseUrl, 'baseUrl is a required param of setShippingInfo()');
    invariant(brandId, 'brandId is a required param of setShippingInfo()');
    invariant(country, 'country is a required param of setShippingInfo()');
    invariant(uberToken, 'uberToken is a required param of setShippingInfo()');
    invariant(body, 'body is a required param of setShippingInfo()');
    invariant(clientId, 'clientId is a required param of setShippingInfo()');

    const query = queryString.stringify({ clearMessages, langId });
    const headers = { 'Content-Type': 'application/json', ...additionalHeaders };
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country}/cart/@self/shipping_info${query ? `?${query}` : ''}`;

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'PUT', body: JSON.stringify(body) }), uberToken, clientId, clientSecret),
        'setShippingInfo',
    );
}
